module.exports = __webpack_public_path__ + "static/media/ZazoSell.b063f1d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/ZazoSell.jpg
// module id = 449
// module chunks = 0